<div class="flex gap-1 whitespace-nowrap" [title]="getTooltip()">
    <ng-content select="[before-label]" />
    <span>{{ label | translate }}:</span>
    @if (value) {
        <span class="truncate font-bold">{{ value }}</span>
    } @else {
        <span class="truncate font-bold">
            <ng-content />
        </span>
    }
</div>
